import { postToIframe } from 'dibs-xdomain-poster';
import SV from 'server-vars';

import { currentUserEmail, currentUserID } from './userHelpers';

export default function sendTradeApplicationToTfa(tradeApplicationData, tfaTradeConfig = {}) {
    const leadSourceDetails = SV.get('tradeApplicationServerVars.leadSourceDetails') || '';
    const emailField = tfaTradeConfig.userEmailField;

    const tradeDataWithUserData = {
        ...tradeApplicationData,
        [tfaTradeConfig.userEmailField]: tradeApplicationData[emailField] || currentUserEmail() || '',
        [tfaTradeConfig.userIdField]: currentUserID() || '',
        [tfaTradeConfig.leadSourceDetailField]: leadSourceDetails
    };

    return postToIframe(tfaTradeConfig.url, tradeDataWithUserData)
        .catch(err => console.warn('postToIframe failed', err));
};



// WEBPACK FOOTER //
// ./assets/js/postAuth/sendTradeAppToTfa.es.js